import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { visitFlow } from "@/mocks/clinic";

export default function ForFirstVisit() {
  return (
    <section id="first-visit" className="bg-background-100 py-16 md:py-24 lg:py-28">
      <div className="u-container">
        <Reveal>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <SectionHeading en={visitFlow.headingEn} jp={visitFlow.lead} />
            <p className="max-w-sm text-[13px] leading-[2] text-foreground-700">
              ご来院からアフターケアまでの流れをご案内します。途中でご不明な点があれば、いつでもお尋ねください。
            </p>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <ol className="mt-12 grid grid-cols-1 gap-px overflow-hidden border border-foreground-950/12 bg-foreground-950/12 md:mt-16 sm:grid-cols-2 lg:grid-cols-4">
            {visitFlow.steps.map((step) => (
              <li key={step.no} className="flex flex-col bg-background-50 p-7">
                <div className="flex items-center justify-between">
                  <span className="font-label text-[12px] tracking-[0.25em] text-secondary-600">{step.no}</span>
                  <span className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-700">
                    <i className={`${step.icon} text-base`} aria-hidden />
                  </span>
                </div>
                <h3 className="mt-6 font-heading text-[16px] text-foreground-950">{step.title}</h3>
                <p className="mt-3 text-[12px] leading-[1.9] text-foreground-700">{step.text}</p>
              </li>
            ))}
            <li className="flex flex-col justify-center bg-secondary-100/70 p-7">
              <span className="en-eyebrow text-[10px] text-secondary-800">CONSULTATION</span>
              <p className="mt-4 font-heading text-[15px] leading-[1.8] text-foreground-900">
                相談して決めたい方も、
                <br />
                お気軽にどうぞ。
              </p>
              <i className="ri-arrow-right-down-line mt-5 text-xl text-accent-700" aria-hidden />
            </li>
          </ol>
        </Reveal>
      </div>
    </section>
  );
}